var _rect, _rect2, _circle, _circle2, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgTextBgMob = function SvgTextBgMob(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 312,
    height: 422,
    fill: "none"
  }, props), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 429.739,
    height: 308.696,
    x: 171.262,
    y: -17.739,
    fill: "url(#text-bg-mob_svg__a)",
    rx: 18.758,
    transform: "rotate(90 171.262 -17.739)"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    width: 161,
    height: 250,
    x: 289,
    y: -129,
    fill: "url(#text-bg-mob_svg__b)",
    rx: 26.19
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 317.5,
    cy: 381.5,
    r: 15.909,
    stroke: "#9948FF",
    strokeWidth: 3.182
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 24.5,
    cy: 411.5,
    r: 9.333,
    stroke: "#fff",
    strokeWidth: 2.333
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "text-bg-mob_svg__a",
    x1: 386.131,
    x2: 386.131,
    y1: -17.739,
    y2: 290.957,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.008,
    stopColor: "#1600E5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.866,
    stopColor: "#5C11C4"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "text-bg-mob_svg__b",
    x1: 369.5,
    x2: 369.5,
    y1: -129,
    y2: 121,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.008,
    stopColor: "#A900E5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.866,
    stopColor: "#481EE6"
  })))));
};
export { SvgTextBgMob as ReactComponent };